{% block swag_migration_base_content_view %}
    {% block swag_migration_index_tabs %}
        <sw-tabs
            class="swag-migration-index-tabs"
            position-identifier="swag-migration-index-tabs"
        >
            {% block swag_migration_index_tab_main %}
                <sw-tabs-item
                    :route="{ name: 'swag.migration.index.main' }"
                    :title="$tc('swag-migration.general.tabMain')"
                >
                    {{ $tc('swag-migration.general.tabMain') }}
                </sw-tabs-item>
            {% endblock %}

            {% block swag_migration_index_tab_data_selector %}
                <sw-tabs-item
                    :route="{ name: 'swag.migration.index.dataSelector' }"
                    :title="$tc('swag-migration.general.tabDataSelector')"
                    :disabled="!acl.can('swag_migration.editor')"
                >
                    {{ $tc('swag-migration.general.tabDataSelector') }}
                </sw-tabs-item>
            {% endblock %}

            {% block swag_migration_index_tab_history %}
                <sw-tabs-item
                    v-if="hasHistory"
                    :route="{ name: 'swag.migration.index.history' }"
                    :title="$tc('swag-migration.general.tabHistory')"
                >
                    {{ $tc('swag-migration.general.tabHistory') }}
                </sw-tabs-item>
            {% endblock %}
        </sw-tabs>
    {% endblock %}

    {% block swag_migration_index_content_view %}
        <router-view ref="contentComponent"/>
    {% endblock %}
{% endblock %}
